<div class="olci-top-alert">
  @for (error of errorMessages; track error) {
    <rcg-notification-message
      class="container no-print"
      [brand]="brandName"
      [variant]="'inline'"
      [type]="error.errorType"
      [notificationId]="'uniqueId'"
      [description]="error.errorMessage"
      [dismissible]="false"
    ></rcg-notification-message>
  }
</div>
